@for (lang of languages; track $index) {
  <button
      (click)="!isDisabled && changeLanguage(lang)"
      vee-btn="outlined"
      [disabled]="isDisabled"
      [ngClass]="{ active: value === lang }">
    {{ languageLabels[lang] }}
  </button>
}
